import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface SortDownProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const SortDown: React.FunctionComponent<React.PropsWithChildren<SortDownProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}): any => (
    <SVGBase viewBox="0 0 171.969 100.399" height={height} width={width} title={title} fill={fill} {...rest}>
        <path
            d="M31.4,288H174.439a14.443,14.443,0,0,1,10.217,24.642l-71.521,71.521a14.365,14.365,0,0,1-20.374,0L21.181,312.642A14.443,14.443,0,0,1,31.4,288Z"
            transform="translate(-16.934 -288)"
        />
    </SVGBase>
);

export default SortDown;
